import registerConsumerPrompt from "emun.auth/register-consumer-prompt";
import registerRetailerChoicePrompt from "emun.auth/register-choice-prompt";
import registerRetailerPromptFormIO from "emun.auth/register-retailer.prompt";
import registerRetailerPrompt from "emun.auth/register-retailer-prompt";
import actionsTemplateUrl from "emun.auth/login-prompt.actions.htm";
import registerCurrentAccountPrompt from "emun.auth/register-current-acct-prompt";
import resetPasswordPrompt from "emun.auth/reset-password/reset-password-prompt";
import basicController from "servicestack/basic.controller.properties";
import authConfig from "emun.auth/auth.config"; //get shared

export default class LoginPromptController {
  constructor() {
    basicController(this);
    let $ctrl = this;
    $ctrl.config = authConfig;
    $ctrl.actionsTemplateUrl = actionsTemplateUrl;
    $ctrl.bus = $ctrl.$session.bus;
    $ctrl.bus.validationErrors = {};
  }

  $onInit() {
    console.log("onInit.actionsTemplateUrl", this);
    if (!this.request) {
      this.request = {};
    }
  }

  registerConsumer() {
    let $ctrl = this;
    $ctrl.$dismiss && $ctrl.$dismiss("register");
    return registerConsumerPrompt({});
  }

  registerRetailer() {
    let $ctrl = this;
    $ctrl.$dismiss && $ctrl.$dismiss("register");
    return registerRetailerPrompt({});
  }

  registerRetailerFormIO() {
    let $ctrl = this;
    $ctrl.$dismiss && $ctrl.$dismiss("register");
    return registerRetailerPromptFormIO({});
  }

  registerCurrentAccount() {
    let $ctrl = this;
    $ctrl.$dismiss && $ctrl.$dismiss("register");
    return registerCurrentAccountPrompt({});
  }

  register() {
    let $ctrl = this;
    $ctrl.$close && $ctrl.$dismiss("register");
    if (
      $ctrl.$session.availableBusinessModels.indexOf("Wholesale") !== -1 &&
      $ctrl.$session.availableBusinessModels.indexOf("Retail") === -1
    ) {
      console.warn("registerRetailerAction", authConfig.registerRetailerAction);
      if (authConfig.registerRetailerAction === "choice")
        return registerRetailerChoicePrompt({});
      if (authConfig.registerRetailerAction === "existing")
        return registerCurrentAccountPrompt({});
      if (authConfig.formIORegistration) {
        return registerRetailerPromptFormIO({});
      } else {
        return registerRetailerPrompt({});
      }
    } else {
      return registerConsumerPrompt({});
    }
  }

  resetPassword() {
    let $ctrl = this;
    $ctrl.$dismiss && $ctrl.$dismiss("resetPassword");
    return resetPasswordPrompt({ email: $ctrl.request.userName });
  }

  submit() {
    let $ctrl = this;
    $ctrl.request.rememberMe = true;
    return $ctrl.$session.login($ctrl.request).then(
      (res) => $ctrl.$close && $ctrl.$close(res),
      (res) => console.debug("login.res", res)
    );
  }
}
